import { create } from 'zustand';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const DEFAULT_CONFIG = {
  app_name: 'OneView',
  primary_color: '#000000',
  accent_color: '#EF4444',
  logo_url: '',
  favicon_url: '',
  custom_css: '',
};

export const useWhiteLabelStore = create((set, get) => ({
  config: { ...DEFAULT_CONFIG },
  loaded: false,

  fetchConfig: async (authHeader) => {
    try {
      const res = await axios.get(`${API}/settings/whitelabel`, { headers: authHeader });
      const config = { ...DEFAULT_CONFIG, ...res.data };
      set({ config, loaded: true });
      applyWhiteLabel(config);
    } catch {
      set({ config: { ...DEFAULT_CONFIG }, loaded: true });
      applyWhiteLabel(DEFAULT_CONFIG);
    }
  },

  reset: () => {
    set({ config: { ...DEFAULT_CONFIG }, loaded: false });
    applyWhiteLabel(DEFAULT_CONFIG);
  },
}));

function applyWhiteLabel(config) {
  const root = document.documentElement;

  // CSS custom properties for colors
  root.style.setProperty('--wl-primary', config.primary_color);
  root.style.setProperty('--wl-accent', config.accent_color);

  // Override shadcn primary color with accent_color when customized
  if (config.accent_color && config.accent_color !== '#EF4444') {
    const hex = config.accent_color.replace('#', '');
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    // Convert to HSL for shadcn CSS vars
    const [h, s, l] = rgbToHsl(r, g, b);
    root.style.setProperty('--primary', `${h} ${s}% ${l}%`);
    root.style.setProperty('--primary-foreground', l > 50 ? '0 0% 10%' : '0 0% 98%');
    root.style.setProperty('--ring', `${h} ${s}% ${l}%`);
  }

  // Favicon
  if (config.favicon_url) {
    let link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }
    link.href = config.favicon_url;
  }

  // Title
  if (config.app_name && config.app_name !== 'OneView') {
    document.title = `${config.app_name} - Monitoring Dashboard`;
  }

  // Custom CSS
  let styleEl = document.getElementById('wl-custom-css');
  if (config.custom_css) {
    if (!styleEl) {
      styleEl = document.createElement('style');
      styleEl.id = 'wl-custom-css';
      document.head.appendChild(styleEl);
    }
    styleEl.textContent = config.custom_css;
  } else if (styleEl) {
    styleEl.remove();
  }
}


function rgbToHsl(r, g, b) {
  r /= 255; g /= 255; b /= 255;
  const max = Math.max(r, g, b), min = Math.min(r, g, b);
  let h, s, l = (max + min) / 2;
  if (max === min) { h = s = 0; }
  else {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch (max) {
      case r: h = ((g - b) / d + (g < b ? 6 : 0)) / 6; break;
      case g: h = ((b - r) / d + 2) / 6; break;
      default: h = ((r - g) / d + 4) / 6;
    }
  }
  return [Math.round(h * 360), Math.round(s * 100), Math.round(l * 100)];
}
